'use client';

import posthog from 'posthog-js';
import { isPostHogInitialized } from '@/instrumentation-client';
import {
  getPostHogDeploymentProperties,
  getPostHogExceptionProperties,
} from './posthog-errors';

type CapturePostHogClientExceptionOptions = {
  digest?: string;
  errorSource: string;
};

export function capturePostHogClientException(
  error: unknown,
  { digest, errorSource }: CapturePostHogClientExceptionOptions,
): void {
  if (!isPostHogInitialized()) return;

  try {
    posthog.captureException(
      error,
      getPostHogExceptionProperties({
        digest,
        error_source: errorSource,
        ...getPostHogDeploymentProperties(),
      }),
    );
  } catch (captureError) {
    console.error(
      '[PostHog] Failed to capture client exception:',
      captureError,
    );
  }
}
